import type { PathologyCreateOrderFormRequestSchema } from '@quromedical/models';
import type { z } from 'zod';

export type PathologyCreateOrderForm = z.infer<
  typeof PathologyCreateOrderFormRequestSchema
>;
